import React from "react";

interface LogoutIconProps {
  className?: string;
}

export const LogoutIcon = ({ className }: LogoutIconProps) => (
  <svg
    className={className}
    width="17"
    height="12"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 0H5.625C5.875 0 6 0.125 6 0.375V0.625C6 0.875 5.875 1 5.625 1H1.5C1.35417 1 1.22917 1.05208 1.125 1.15625C1.04167 1.23958 1 1.35417 1 1.5V10.5C1 10.6458 1.04167 10.7708 1.125 10.875C1.22917 10.9583 1.35417 11 1.5 11H5.625C5.875 11 6 11.125 6 11.375V11.625C6 11.875 5.875 12 5.625 12H1.5C1.08333 12 0.729167 11.8542 0.4375 11.5625C0.145833 11.2708 0 10.9167 0 10.5V1.5C0 1.08333 0.145833 0.729167 0.4375 0.4375C0.729167 0.145833 1.08333 0 1.5 0ZM10.2188 0.625C10.4062 0.4375 10.5833 0.4375 10.75 0.625L15.9062 5.75C16.0729 5.91667 16.0729 6.08333 15.9062 6.25L10.75 11.375C10.5833 11.5625 10.4062 11.5625 10.2188 11.375L10 11.1562C9.8125 10.9896 9.8125 10.8125 10 10.625L14.125 6.53125H5.375C5.125 6.53125 5 6.40625 5 6.15625V5.84375C5 5.59375 5.125 5.46875 5.375 5.46875H14.125L10 1.375C9.8125 1.1875 9.8125 1.01042 10 0.84375L10.2188 0.625Z"
      fill="black"
    />
  </svg>
);

LogoutIcon.defaultProps = {
  className: "",
};
